import {
  IN_POSSESSION,
  OUT_OF_POSSESSION,
  MIXED_POSSESSION
} from "@/assets/js/tactics";

const playingStyles = {
  mentality: { possessionType: MIXED_POSSESSION },
  passingDirectness: { possessionType: IN_POSSESSION },
  closingDown: { possessionType: OUT_OF_POSSESSION },
  attackingDepthFront: { possessionType: IN_POSSESSION },
  defensiveDepthFront: { possessionType: OUT_OF_POSSESSION },
  attackingDepthBack: { possessionType: IN_POSSESSION },
  defensiveDepthBack: { possessionType: OUT_OF_POSSESSION },
  attackingWidth: { possessionType: IN_POSSESSION },
  defensiveWidth: { possessionType: OUT_OF_POSSESSION },
  tempo: { possessionType: IN_POSSESSION },
  verticalMovement: { possessionType: IN_POSSESSION },
  lateralMovement: { possessionType: IN_POSSESSION },
  verticalDribbling: { possessionType: IN_POSSESSION },
  lateralDribbling: { possessionType: IN_POSSESSION },
  passingRisk: { possessionType: IN_POSSESSION },
  crossing: { possessionType: IN_POSSESSION },
  clearances: { possessionType: IN_POSSESSION },
  shootingRisk: { possessionType: IN_POSSESSION },
  creativeFreedom: { possessionType: IN_POSSESSION },
  timeWasting: { possessionType: IN_POSSESSION },
  playingForSetPieces: { possessionType: IN_POSSESSION },
  steppingUp: { possessionType: OUT_OF_POSSESSION },
  marking: { possessionType: OUT_OF_POSSESSION },
  tackling: { possessionType: OUT_OF_POSSESSION },
  trackingBack: { possessionType: OUT_OF_POSSESSION },
  counterAttacking: { possessionType: IN_POSSESSION },
  counterPressing: { possessionType: OUT_OF_POSSESSION }
};

export default playingStyles;
